import React from "react";
import { CTABanner } from "../components/CTABanner";
import { FadeInOnScroll } from "../components/FadeInOnScroll";

const services = [
  {
    icon: "🦷",
    title: "Stomatologie Generală",
    desc: "Baza îngrijirii dentare — consultații, tratamente de rutină și prevenție.",
    items: [
      ["Consultație inițială", "Gratuită"],
      ["Consultație de control", "80 lei"],
      ["Igienizare profesională (detartraj + periaj)", "250 lei"],
      ["Obturație (plombă) compozit", "180 – 280 lei"],
      ["Extracție dentară simplă", "200 lei"],
      ["Extracție chirurgicală", "350 – 500 lei"],
      ["Tratament de canal (endodonție)", "400 – 700 lei"],
    ],
  },
  {
    icon: "🌟",
    title: "Albire Dentară",
    desc: "Redă strălucirea zâmbetului tău cu sisteme profesionale certificate.",
    items: [
      ["Albire profesională la cabinet (Zoom / LED)", "900 lei"],
      ["Albire acasă (gutiere personalizate + gel)", "550 lei"],
      ["Pachet combinat cabinet + acasă", "1.200 lei"],
    ],
  },
  {
    icon: "🔧",
    title: "Implantologie",
    desc: "Soluția permanentă și estetică pentru dinții lipsă.",
    items: [
      ["Implant dentar (titan, Swiss)", "2.800 lei / implant"],
      ["Coroană pe implant (zirconiu)", "1.500 lei"],
      ["Pachet complet implant + coroană", "3.900 lei"],
      ["Radiografie 3D CBCT", "300 lei"],
      ["Augmentare osoasă (grefare)", "1.500 – 3.000 lei"],
    ],
  },
  {
    icon: "😁",
    title: "Ortodonție",
    desc: "Aliniere dentară pentru un zâmbet perfect, la orice vârstă.",
    items: [
      ["Consultație ortodontică + plan tratament", "Gratuită"],
      ["Aparat fix metalic (ambele arcade)", "3.500 lei"],
      ["Aparat fix ceramic (estetic)", "5.000 lei"],
      ["Aparate invizibile (aligneri) — set complet", "6.500 – 9.000 lei"],
      ["Retentor fix după tratament", "400 lei / arcadă"],
    ],
  },
  {
    icon: "👑",
    title: "Estetică Dentară & Proteză",
    desc: "Restaurări estetice pentru un zâmbet de vis.",
    items: [
      ["Coroană ceramică (zirconiu)", "1.200 lei"],
      ["Coroană metalo-ceramică", "700 lei"],
      ["Fațetă ceramică", "1.500 lei / dinte"],
      ["Punte dentară (3 elemente)", "2.100 – 3.600 lei"],
      ["Proteză mobilă acrilică totală", "1.800 lei"],
      ["Proteză mobilă parțială", "1.200 lei"],
    ],
  },
  {
    icon: "🧒",
    title: "Stomatologie Pediatrică",
    desc: "Îngrijire blândă și specializată pentru zâmbetul celor mici.",
    items: [
      ["Consultație copil (0–14 ani)", "Gratuită"],
      ["Sigilare molari", "150 lei / dinte"],
      ["Obturație dinte de lapte", "120 – 180 lei"],
      ["Extracție dinte de lapte", "120 lei"],
      ["Fluorizare profesională", "100 lei"],
    ],
  },
];

export default function Servicii() {
  return (
    <div data-testid="page-services">
      <section className="page-header" data-testid="services-page-header">
        <div className="container-main">
          <h1>Serviciile Noastre</h1>
          <p>Tratamente complete, prețuri transparente</p>
        </div>
      </section>

      <section className="section-white">
        <div className="container-main">
          <div className="intro-block">
            <p>
              La DentaPro Clinic oferim o gamă completă de servicii stomatologice pentru întreaga
              familie. Mai jos găsiți lista completă a tratamentelor noastre, însoțite de prețuri
              orientative.
            </p>
            <p className="intro-note">
              * Prețurile sunt orientative și pot varia în funcție de complexitatea cazului.
              Consultația inițială este gratuită.
            </p>
          </div>

          <div style={{ marginTop: 50 }}>
            {services.map((s, idx) => (
              <FadeInOnScroll key={idx} delay={idx * 60}>
                <div className="service-section" data-testid={`service-section-${idx}`}>
                  <div className="service-header">
                    <div className="service-icon">{s.icon}</div>
                    <h2>{s.title}</h2>
                  </div>
                  <p>{s.desc}</p>
                  <table className="price-table">
                    <tbody>
                      {s.items.map(([name, price], i) => (
                        <tr key={i}>
                          <td>{name}</td>
                          <td>{price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </FadeInOnScroll>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
